<template>
    <keep-alive>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size md_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"
                        ><span class="sr_only">popup close</span></a
                    >
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>{{ $t('TITLE.POPUP.SELECT.ROLE') }}</i>
                        </dt>
                        <dd>
                            <div class="Select_wrap">
                                <ul class="txt_sel">
                                    <li class="tit">{{ $t('FIELD.FAQ.CORP') }}</li>
                                    <li data-input-type="select" class="sel">
                                        <select class="slt_white w50p" v-model="rhqCd" @change="changeRhqCd()">
                                            <option value="" selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                        <select class="slt_white w40p" v-model="corpNo">
                                            <option value="" selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </li>
                                </ul>
                            </div>

                            <!-- Grid -->
                            <div class="grid_wrap mt10">
                                <div class="grid_total">
                                    {{ $t('TITLE.TOTAL.COUNT') }} : <em>{{ resultCount | numberFormat }}</em>
                                </div>
                                <table class="scroll_table">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="35%" />
                                        <col width="*" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th width="15%" class="tC">{{ $t('FIELD.GLOVAL.CHECK') }}</th>
                                            <th width="35%" class="tC">{{ $t('FIELD.ROLE.CODE') }}</th>
                                            <th width="*" class="tC">{{ $t('FIELD.ROLE.NAME') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text_center">
                                        <tr v-for="item in roleAuthList" :key="item.code" style="height:25px;">
                                            <td width="15%" class="no_pading" style="height:25px;">
                                                <label class="radiobox-wrap">
                                                    <input
                                                        type="radio"
                                                        name="chkAuth"
                                                        value="item.AUTHID"
                                                        @click="selectRowChk(item)"
                                                    />
                                                    <i class="radio-icon"></i>
                                                </label>
                                            </td>
                                            <td width="35%">{{ item.AUTHID }}</td>
                                            <td width="*">{{ item.AUTHNM }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <dd class="scroll_btm">
                                <div class="btn_modal_wrap topLine">
                                    <div class="btn_right">
                                        <a href="JavaScript:" class="btn_white" title @click="$emit('close')">{{
                                            $t('BUTTON.GLOBAL.CANCEL')
                                        }}</a>
                                        <a href="JavaScript:" class="btn_blue" title @click="roleAddSave()">{{
                                            $t('BUTTON.GLOBAL.SAVE')
                                        }}</a>
                                    </div>
                                </div>
                            </dd>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import { mapGetters } from 'vuex';
import api from '@/service';

export default {
    name: 'searchRolePopup',
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        }
    },
    components: {},
    props: {
        pRhqCdList: { type: Array, default: [] },
        rtnRoleFunc: { type: Function },
    },
    data() {
        return {
            rhqCd: '',
            corpNo: '',
            checkedAuth: '',
            resultCount: 0,
            rhqCdList: this.pRhqCdList,
            corpNoList: [],
            roleAuthList: [],
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(pCode) {
            this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
                this.corpNo = '';
            });
        },
        async onSearch() {
            SDLUtil.showLoadingBar(true);
            return await axios
                .get(`${SDLUtil.API_URL}/basis/admin/user/userAuthPopup.skp`, qs.stringify({}), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                })
                .then(resp => {
//                    console.log('pop.resp.data ==> ', resp.data);
                    this.resultCount = resp.data.rowCount;
                    this.roleAuthList = resp.data.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        changeRhqCd() {
            if (this.rhqCd) {
                this.loadSubsiCodes(this.rhqCd);
            } else {
                this.corpNoList = [];
                this.corpNo = '';
            }
        },
        selectRowChk(item) {
            // 개별 checkbix click
            this.checkedAuth = item.AUTHID;
        },
        roleAddSave() {
            let param = { authRhqCd: this.rhqCd, authCorpNo: this.corpNo, authId: this.checkedAuth };
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/user/getAddAuthRole.skp`, qs.stringify(param), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
//                    console.log('save.resp.data ==> ', resp.data);
                    this.rtnRoleFunc(resp.data.rowData);
                    this.$emit('close');
                })
                .catch(err => {
                    console.log('Error occured : ', err);
                });
        },
    },
    mounted() {
        this.rhqCdList = this.pRhqCdList;
        //        this.rhqCd = this.rhqCdList[0].code;
        this.onSearch();
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/user/RoleAddPopup.vue